import { render, staticRenderFns } from "./order-header.vue?vue&type=template&id=07711fac&scoped=true"
import script from "./order-header.vue?vue&type=script&lang=js"
export * from "./order-header.vue?vue&type=script&lang=js"
import style0 from "./order-header.vue?vue&type=style&index=0&id=07711fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07711fac",
  null
  
)

export default component.exports